import { FC } from "react";

import { FoodBusinessForm } from "../HubspotForms";

type PageFormProps = {
  buttonLabel: string;
};

const PageForm: FC<PageFormProps> = ({ buttonLabel }) => {
  return (
    <section className="relative z-10 isolate flex w-full flex-col items-center px-[20px] py-[40px] bg-[#F8F8F8]">
      <h4 className="w-full max-w-[400px] mx-auto text-[24px] font-raleway font-bold text-primaryDark-0 text-center mb-[24px]">
        <span className="text-primaryDark-400"> Join </span> HomeCook's
        Community Now!
      </h4>

      <div className="w-full max-w-[400px] mx-auto rounded-[16px]">
        <FoodBusinessForm submitLabel={buttonLabel} layout="mobile" />
      </div>
    </section>
  );
};

export default PageForm;
